import * as React from 'react';
export const EHSvg = React.forwardRef(function EHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#F6F9FC',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M11 4.268a1.75 1.75 0 1 0 0 3.464 2 2 0 1 1 0-3.464ZM11 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 8V4h1v4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 2v2h16V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 8v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 10V8H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M.7 11.52A2.01 2.01 0 0 1 0 9.99V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039L7 5.996.777 11.478a.5.5 0 0 1-.076.042Z',
      }),
    ),
  );
});
EHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var EH = {
  category: 'flag',
  colorable: false,
  name: 'EH',
  svg: EHSvg,
};
